import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate } from "react-router-dom";
import routes from '../../libs/routes';
import images from "../../libs/images";
import { useDispatch, useSelector } from 'react-redux';
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import Popup01 from "../../pages/popup/Popup01"

import * as API from "../../libs/service";

export default function Login_pw_help() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [idTitleView, setIdTitleView] = useState(false);
    const [idValue, setIdValue] = useState('');
    const [idAster, setIdAster] = useState(true);
    const [idErr, setIdErr] = useState(0);

    const [pwSuc, setPwSuc] = useState(false);

    const [pwTitleView, setPwTitleView] = useState(false);
    const [pwview, setPwview] = useState(false);
    const [pwValue, setPwValue] = useState('');
    const [pwAster, setPwAster] = useState(true);

    const [pwChkTitleView, setPwChkTitleView] = useState(false);
    const [pwChkview, setPwChkview] = useState(false);
    const [pwChkValue, setPwChkValue] = useState('');
    const [pwChkAster, setPwChkAster] = useState(true);
    const [pwErr, setPwErr] = useState(0);
    const [pwChkErr, setPwChkErr] = useState(0);

    const [pwchkSuc, setPwChkSuc] = useState(false);

    const [code, setCode] = useState('');
    const [notcode, setNotcode] = useState(true);
    const [codeErr, setCodeErr] = useState(false);

    const [time, setTime] = useState(180);
    const [timecut, setTimecut] = useState(false);

    const [loginHelpStep, setLoginHelpStep] = useState(0);

    /* useEffect(() => {
        console.log(pwchkSuc);
    }, [pwchkSuc]); */

    useEffect(() => {
        if(mbData?.idx) {
            navigate(routes.main);
        }
    }, [navigate]);

    useEffect(() => {
        if (loginHelpStep === 1 && time > 0) {
            const timer = setInterval(() => {
                setTime(prevTime => {
                    if (prevTime === 1) {
                        setTimecut(true);
                    }
                    return prevTime - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        } else if (time === 0) {
            setTimecut(true);
        }
    }, [loginHelpStep, time]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    const ReCode = async () => {
        await CodeFunc();
        setTime(180);
        setTimecut(false);
        setCode('');
        setNotcode(true);
    };

    const CodeFunc = async () => {
        let sender = {
            email: idValue,
            help: true,
            language: lang === 0 ? 'ko' : 'en'
        };
        if(idValue === ''){
            setIdErr(2);
            return;
        }
        dispatch(loadingStart());

        await API.post('user/RegisterCode', sender).then(({ data }) => {
            if(data?.msg === 'help_err') {
                setIdErr(1)
            } else if(data?.msg === 'help_err_google'){
                setIdErr(3)
            } else if(data?.msg === 'help_err_abort'){
                setIdErr(4)
            } else {
                setPwChkValue(data?.data);
                setIdErr(0)
                setLoginHelpStep(1)
            }

        }).catch(err => {
            /* console.log(err.response.data) */
            dispatch(open({
                component: 
                    <Popup01 
                        x_btn={true}
                        text1={lang === 0 ? '오류가 발생했습니다.' : 'An error occurred.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                        setFunc={() => {
                            navigate(routes.login)
                        }}
                    />
            }));
        }).finally(() => {
            dispatch(loadingEnd());
        })
    }

    const CodeChkFunc = async () => {
        let sender = {
            email: idValue,
            code: code
        };

        await API.post('user/RegisterCodeChk', sender).then(({ data }) => {
            /* console.log('인증번호 체크', data); */

            setCodeErr(false);
            setLoginHelpStep(2);

        }).catch(err => {
            /* console.log(err.response.data); */
            setCodeErr(true);
        }).finally(() => {
            
        })
    }

    const RegisterFunc = async () => {
        let sender = {
            email: idValue,
            password: pwValue,
            help: true
        };

        /* console.log(sender); */

        dispatch(loadingStart());

        await API.post('user/RegisterPasswordch', sender).then(({ data }) => {
            /* console.log('체크', data); */

            setTimeout(() => {
                localStorage.setItem('regiSuc', '2');
                navigate(routes.login);
            }, 2000);

        }).catch(err => {
            /* console.log(err.response.data); */
            dispatch(open({
                component: 
                    <Popup01 
                        x_btn={true}
                        text1={lang === 0 ? '오류가 발생했습니다.' : 'An error occurred.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                        setFunc={() => {
                            navigate(routes.login)
                        }}
                    />
            }));
        }).finally(() => {
            setTimeout(() => {
                dispatch(loadingEnd());
            }, 2000);
        })
    }

    const InputChange = (event) => {
        const { name, value } = event.target;

        if(name === "login_id") {
            let EmailChk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setIdValue(value)

            if(value) {
                setIdAster(false);
                setIdTitleView(true)
            } else {
                setIdAster(true);
                setIdTitleView(false)
            }

            if(!EmailChk.test(value)) {
                setIdErr(2);
                return;
            } else {
                if (!value.endsWith('@umodeler.com') && /\+[0-9]+(?=@)/.test(value)) {
                    setIdErr(2);
                    return;
                }
                setIdErr(0);
            }

        }

        if(name === "login_password") {
            let pwChk = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,15}$/;
            setPwValue(value)

            if(value) {
                setPwAster(false);
                setPwTitleView(true)
            } else {
                setPwAster(true);
                setPwTitleView(false)
            }

            if(pwChkValue != value) {
                setPwChkErr(1)
                setPwSuc(false)
            } else {
                setPwChkErr(0)
                setPwSuc(true)
            }

            if(!pwChk.test(value)) {
                setPwErr(1)
            } else {
                setPwErr(0)
            }

            if (pwChkValue === value && pwChk.test(value)) {
                setPwSuc(true);
            }
        }

        if(name === "login_password_chk") {
            let pwChk = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,15}$/;
            setPwChkValue(value)

            if(value) {
                setPwChkAster(false);
                setPwChkTitleView(true)
            } else {
                setPwChkAster(true);
                setPwChkTitleView(false)
            }
            
            if(pwValue != value) {
                setPwChkErr(1)
                setPwSuc(false)
            } else {
                setPwChkErr(0)
            }

            if(!pwChk.test(value)) {
                setPwErr(1)
                setPwSuc(false)
            } else {
                setPwErr(0)
            }

            if (pwValue === value && pwChk.test(value)) {
                setPwSuc(true);
            }
        }

        if(name === "code") {
            const onlyNumbers = /^[0-9]*$/;
            setCode(value);

            if(onlyNumbers.test(value)) {
                if(value.length == 4) {
                    setNotcode(false);
                } else {
                    setNotcode(true);
                }
            }
        }
    }

    const StepChkFunc = (step) => {
        if(step == 1) {
            let EmailChk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if(!EmailChk.test(idValue)) {
                setIdErr(2);
                return;
            } else {
                setIdErr(0);
                setLoginHelpStep(1);
            }
        }

        if(step == 2) {

        }
    }
    
    return (
        <div className="login_back pw_help">
            <div className="login_box">
                <div 
                    className="logo"
                    style={{
                        cursor: "pointer"
                    }}
                    onClick={() => {
                        navigate(routes.login)
                    }}
                >
                    <img src={require("../../assets/icon/logo1.svg").default} alt="logo"/>
                </div>

                {loginHelpStep == 0 &&
                    <>
                        <p className="title">{lang === 0 ? "비밀번호 찾기" : "Reset Password"}</p>

                        <span className="sub_title">{lang === 0 ? "가입하신 이메일로 인증번호를 보내드립니다." : "A verification code will be sent to your registered email address."}</span>

                        <div className="login_input_box">
                            <div className="input_div">
                                {idTitleView &&
                                    <div className="input_focus id_focus">
                                        <p>{lang === 0 ? "이메일" : "Email"}</p>
                                        <span 
                                            className="input_aster"
                                            style={{
                                                left: '32px',
                                                top: '-2px'
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                }
                                <input 
                                    type="text" 
                                    placeholder={lang === 0 ? "이메일" : "Email"} 
                                    className="input_id"
                                    name="login_id"
                                    value={idValue}
                                    onChange={InputChange}
                                    onBlur={() => {
                                        setIdTitleView(false)
                                    }}
                                />
                                {idAster && 
                                    <span 
                                        className="input_aster"
                                        style={{
                                            left: '64px',
                                            top: idTitleView ? '20px' : '15px'
                                        }}
                                    >
                                        *
                                    </span>
                                }
                            </div>
                            {idErr == 1 &&<span className="err_msg id">{lang === 0 ? "가입된 이메일 주소가 아닙니다." : "The email address is not registered."}</span>}
                            {idErr == 2 && <span className="err_msg id">{lang === 0 ? "이메일 형식이 올바르지 않습니다." : "Invalid email format."}</span>}
                            {idErr == 3 && <span className="err_msg id">{lang === 0 ? "등록되지 않은 이메일입니다." : "This email is not registered."}</span>}
                            {idErr == 4 && <span className="err_msg id">{lang === 0 ? "탈퇴된 계정입니다." : "This account has been deactivated."}</span>}
                        </div>

                        <div className="login_btn_div">
                            <button 
                                type="button" 
                                className="login_btn"
                                onClick={() => {
                                    CodeFunc();
                                }}
                            >
                                {lang === 0 ? "인증번호 받기" : "Send Verification Code"}
                            </button>
                        </div>
                    </>
                }

                {loginHelpStep == 1 &&
                        <>
                            <p className="title">{lang === 0 ? "비밀번호 찾기" : "Reset Password"}</p>
                            <span
                                style={{
                                    fontSize: '16px',
                                    marginBottom: '-20px'
                                }}
                            >
                                {lang === 0 ? "가입하신 이메일로 인증번호를 보내드립니다." : "A verification code has been sent to your email."}
                            </span>

                            <div className="login_input_box">
                                <div className="input_div" style={{ background: '#f1f1f1' }}>
                                    <input 
                                        type="text" 
                                        placeholder={lang === 0 ? "이메일" : "Email"} 
                                        className="input_id"
                                        name="login_id"
                                        value={idValue}
                                        style={{ background: '#f1f1f1' }}
                                        readOnly
                                    />
                                </div>

                                <span className="err_msg id" style={{ color: '#0E6AF4' }}>{lang === 0 ? "이메일로 인증번호를 전송했습니다." : "A verification code has been sent to your email."}</span>

                                <div className="input_div" style={{ marginTop: '20px' }}>
                                    <input 
                                        type="text" 
                                        placeholder={lang === 0 ? "인증번호 입력" : "Enter Verification Code"} 
                                        className="input_id"
                                        name="code"
                                        value={code}
                                        onChange={InputChange}
                                        maxLength={4}
                                    />
                                    <span 
                                        style={{ 
                                            color: '#0E6AF4', 
                                            fontSize: '12px',
                                            position: 'absolute',
                                            right: '12px',
                                            top: 'calc(50% - 10px)'
                                        }}
                                    >
                                        {formatTime(time)}
                                    </span>
                                </div>

                                {codeErr &&
                                    <span className="err_msg id">{lang === 0 ? "인증번호가 일치하지 않습니다." : "Verification code does not match."}</span>
                                }

                                <button 
                                    type="button" 
                                    className="login_btn regi"
                                    onClick={() => {
                                        if(!notcode && !timecut) {
                                            CodeChkFunc()
                                        }
                                        if(timecut) {
                                            dispatch(open({
                                                component: 
                                                    <Popup01 
                                                        x_btn={true}
                                                        text1={lang === 0 ? '인증번호가 만료되었습니다.' : 'The verification code has expired.'}
                                                        longButton={lang === 0 ? '확인' : 'OK'}
                                                    />
                                            }));
                                        }
                                    }}
                                    style={{
                                        background: notcode ? '#ccc' : ''
                                    }}
                                >
                                    {lang === 0 ? "확인" : "OK"}
                                </button>
                            
                                {timecut &&
                                    <button 
                                        type="button" 
                                        className="login_btn regi"
                                        onClick={() => {
                                            ReCode()
                                        }}
                                    >
                                        {lang === 0 ? "재요청" : "Resend"}
                                    </button>
                                }
                            </div>
                        </>
                    }

                    {loginHelpStep == 2 &&
                        <>
                            <p className="title">{lang === 0 ? "비밀번호 재설정" : "Reset Password"}</p>

                            <input 
                                type="text" 
                                placeholder={lang === 0 ? "이메일" : "Email"} 
                                className="input_id"
                                name="login_id"
                                value={idValue}
                                readOnly
                                style={{ fontWeight: '700' }}
                            />

                            <span
                                style={{
                                    width: '100%',
                                    textAlign: 'left',
                                    color: '#666',
                                    marginTop: '-32px'
                                }}
                            >
                                {lang === 0 ? "비밀번호(8~15자리 영문,숫자,특수문자 혼합)" : "Password (8-15 characters including letters, numbers, and special characters)"}
                            </span>

                            <div className="input_div pw_div" style={{ marginTop: '-20px' }}>
                                {pwTitleView &&
                                    <div className="input_focus pw_focus">
                                        <p>{lang === 0 ? "비밀번호" : "Password"}</p>
                                        <span 
                                            className="input_aster"
                                            style={{
                                                left: lang === 0 ? '42px' : '54px',
                                                top: '-2px'
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                }
                                <input 
                                    type={!pwview ? "password" : "text"} 
                                    placeholder={lang === 0 ? "비밀번호" : "Password"} 
                                    className="input_pw"
                                    name="login_password"
                                    value={pwValue}
                                    onChange={InputChange}
                                    onBlur={() => {
                                        setPwTitleView(false)
                                    }}
                                    maxLength={15}
                                />
                                {!pwview ?
                                    <img 
                                        src={require("../../assets/icon/eye_off.svg").default}
                                        alt="show"
                                        onClick={() => {
                                            setPwview(true)
                                        }}  
                                    />
                                    :
                                    <img 
                                        src={require("../../assets/icon/eye_on.svg").default}
                                        alt="hide"
                                        onClick={() => {
                                            setPwview(false)
                                        }}  
                                    />
                                }
                                {pwAster && 
                                    <span 
                                        className="input_aster"
                                        style={{
                                            left: lang === 0 ? '78px' : '92px',
                                            top: pwTitleView ? '20px' : '15px'
                                        }}
                                    >
                                        *
                                    </span>
                                }
                            </div>

                            <div className="input_div pw_div" style={{ marginTop: '-32px' }}>
                                {pwChkTitleView &&
                                    <div className="input_focus pw_focus">
                                        <p>{lang === 0 ? "재입력" : "Re-enter Password"}</p>
                                        <span 
                                            className="input_aster"
                                            style={{
                                                left: lang === 0 ? '32px' : '105px',
                                                top: '-2px'
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                }
                                <input 
                                    type={!pwChkview ? "password" : "text"} 
                                    placeholder={lang === 0 ? "재입력" : "Re-enter Password"} 
                                    className="input_pw"
                                    name="login_password_chk"
                                    value={pwChkValue}
                                    onChange={InputChange}
                                    onBlur={() => {
                                        setPwChkTitleView(false)
                                    }}
                                    maxLength={15}
                                />
                                {!pwChkview ?
                                    <img 
                                        src={require("../../assets/icon/eye_off.svg").default}
                                        alt="show"
                                        onClick={() => {
                                            setPwChkview(true)
                                        }}  
                                    />
                                    :
                                    <img 
                                        src={require("../../assets/icon/eye_on.svg").default}
                                        alt="hide"
                                        onClick={() => {
                                            setPwChkview(false)
                                        }}  
                                    />
                                }
                                {pwChkAster && 
                                    <span 
                                        className="input_aster"
                                        style={{
                                            left: lang === 0 ? '64px' : '160px',
                                            top: pwChkTitleView ? '20px' : '15px'
                                        }}
                                    >
                                        *
                                    </span>
                                }
                            </div>
                            {pwChkErr == 1 && <span className="err_msg id" style={{ marginTop: '-32px' }}>{lang === 0 ? "비밀번호가 일치하지 않습니다." : "Passwords do not match."}</span>}
                            {pwErr == 1 && <span className="err_msg id" style={{ marginTop: '-32px' }}>{lang === 0 ? "비밀번호 형식이 올바르지 않습니다." : "Password format is incorrect."}</span>}
                            
                            <div className="register_suc_btn_box">
                                <button 
                                    type="button" 
                                    className="login_btn regi"
                                    onClick={() => {
                                        if(pwSuc) {
                                            RegisterFunc()
                                        }
                                    }}
                                    style={{
                                        background: !pwSuc ? '#ccc' : '',
                                        marginTop: '-20px'
                                    }}
                                >
                                    {lang === 0 ? "확인" : "OK"}
                                </button>
                            </div>
                        </>
                    }
            </div>
        </div>
    );
}